import { useCallback, useEffect } from "react";
import {
  EMAIL_REGEX,
  FORMAT_DATE_MM_DD,
  FORMAT_DATE_MM_DD_YYYY,
  ONLY_NUMBERS,
} from "@/constants";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button, ButtonType } from "@/components/common/button";

const DATE_LENGTH = 10;
const PRESSURE_MEASUREMENTS_MIN_LENGTH = 6;
const PRESSURE_MEASUREMENTS_MAX_LENGTH = 7;
export const PLACEHOLDER_VALUE = "placeholder";

const CustomInputQuestion = ({
  question,
  questionValue,

  setQuestionAnswer,
  setQuestionValue,
}: QuizQuestionProps<string>) => {
  const {
    prompt,
    inputType = "text",
    placeholder,
    maxLength = 100,
    unit,
    type,
    required,
  } = question.attributes;

  //   useEffect(() => {
  // if (!questionValue) {
  //   setIsAnswered(!required);
  //   setVal(required ? "" : { answer: "" });
  //   return;
  // }

  // let isAnswered;
  // switch (type) {
  //   case "date":
  //     isAnswered = questionValue.length === DATE_LENGTH;
  //     break;
  //   case "pressure_measurements":
  //     isAnswered =
  //       (questionValue.length || 0) >= PRESSURE_MEASUREMENTS_MIN_LENGTH;
  //     break;
  //   case "email":
  //     isAnswered = EMAIL_REGEX.test(questionValue || "");
  //     break;
  //   default:
  //     isAnswered = !!questionValue;
  // }

  //     setIsAnswered(isAnswered);
  //     setVal(isAnswered ? { answer: questionValue } : "");
  //   }, [questionValue]);

  const handleDateChange = (questionValue: string) => {
    let cleanValue = questionValue.replace(ONLY_NUMBERS, "");

    if (cleanValue.length > 2 && cleanValue.length <= 4) {
      cleanValue = cleanValue.replace(FORMAT_DATE_MM_DD, "$1/$2");
    }

    if (cleanValue.length > 4) {
      cleanValue = cleanValue.replace(FORMAT_DATE_MM_DD_YYYY, "$1/$2/$3");
    }

    setQuestionValue(cleanValue.slice(0, DATE_LENGTH));
  };

  const handlePressureMeasurementsChange = (questionValue: string) => {
    let cleanValue = questionValue.replace(ONLY_NUMBERS, "");

    if (cleanValue.length > 3) {
      cleanValue = cleanValue.slice(0, 3) + "/" + cleanValue.slice(3);
    }

    setQuestionValue(cleanValue.slice(0, PRESSURE_MEASUREMENTS_MAX_LENGTH));
  };

  const handleChange = useCallback(
    (questionValue: string) => {
      switch (type) {
        case "date":
          return handleDateChange(questionValue);
        case "pressure_measurements":
          return handlePressureMeasurementsChange(questionValue);
        default:
          return setQuestionValue(questionValue);
      }
    },
    [type]
  );

  return (
    <div className="relative">
      <input
        value={questionValue}
        type={inputType as string}
        placeholder={placeholder ?? ""}
        maxLength={maxLength}
        onChange={({ target }) => setQuestionValue(target.value)}
        className={`
          ${questionValue ? "border-medium-green" : "border-purple"}
          text-lg sm:text-xl lg:text-3xl pb-2 sm:pb-3 lg:pb-4 border-b-4 w-full outline-none text-center placeholder:text-cool-gray transition duration-500
          `}
      />
      {unit && (
        <span className="text-sm sm:text-base lg:text-lg mb-2 absolute bottom-0 right-0">
          {unit}
        </span>
      )}
      <Button
        type={ButtonType.NEXT}
        disabled={!questionValue.trim()}
        onClick={() => setQuestionAnswer(questionValue)}
      />
    </div>
  );
};

export { CustomInputQuestion };
